var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.domain
    ? _c(
        "div",
        {
          staticClass: "login-page",
          class: "login-position-" + _vm.loginPosition,
          style: _vm.backgroundStyle,
          attrs: { id: "login-panel" }
        },
        [
          _c("div", {
            staticClass: "login-backdrop",
            attrs: { "aria-hidden": "true" }
          }),
          _c(
            "main",
            { staticClass: "login-card" },
            [
              _c("div", {
                staticClass: "login-card__accent",
                attrs: { "aria-hidden": "true" }
              }),
              _vm.isAccountPaid && !_vm.isStarterAccount
                ? _c(
                    "v-container",
                    { staticClass: "login-card__content" },
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          },
                          model: {
                            value: _vm.isValid,
                            callback: function($$v) {
                              _vm.isValid = $$v
                            },
                            expression: "isValid"
                          }
                        },
                        [
                          _c("div", { staticClass: "login-brand" }, [
                            _c("img", {
                              staticClass: "login-logo",
                              attrs: { src: _vm.logo, alt: "" }
                            })
                          ]),
                          _vm.view === "init"
                            ? _c(
                                "section",
                                {
                                  staticClass: "login-form",
                                  attrs: { "aria-live": "polite" }
                                },
                                [
                                  _c("div", {
                                    staticClass: "login-greeting",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.domain.customBranding &&
                                          _vm.domain.customBranding
                                            .loginGreeting
                                      )
                                    }
                                  }),
                                  _vm.entryScreen === "start"
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "login-method",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.magicLinkMode()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "login-method__icon"
                                            },
                                            [
                                              _c("portal-icon", {
                                                attrs: {
                                                  name: "sparkles",
                                                  size: 20
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("login.use-magic-link")
                                              )
                                            )
                                          ]),
                                          _c("portal-icon", {
                                            staticClass: "login-method__arrow",
                                            attrs: {
                                              name: "arrow-right",
                                              size: 17
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.entryScreen === "start"
                                    ? _c(
                                        "div",
                                        { staticClass: "login-divider" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("login.or-password")
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "login-fields" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          "persistent-placeholder": "",
                                          "hide-details": "auto",
                                          autocomplete: "email",
                                          label: _vm.$t("login.email"),
                                          rules: _vm.emailRules
                                        },
                                        model: {
                                          value: _vm.email,
                                          callback: function($$v) {
                                            _vm.email = $$v
                                          },
                                          expression: "email"
                                        }
                                      }),
                                      _vm.entryScreen === "start"
                                        ? _c("v-text-field", {
                                            attrs: {
                                              type: "password",
                                              outlined: "",
                                              "persistent-placeholder": "",
                                              "hide-details": "auto",
                                              autocomplete: "current-password",
                                              label: _vm.$t("login.password"),
                                              rules: _vm.passwordRules
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                _vm.isValid &&
                                                  _vm.handleFormSubmit()
                                              }
                                            },
                                            model: {
                                              value: _vm.password,
                                              callback: function($$v) {
                                                _vm.password = $$v
                                              },
                                              expression: "password"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm.errorMsg
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "login-error",
                                          attrs: { role: "alert" }
                                        },
                                        [
                                          _c("portal-icon", {
                                            attrs: {
                                              name: "alert-circle",
                                              size: 18
                                            }
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.errorMsg))
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "login-submit",
                                      attrs: {
                                        elevation: "0",
                                        color: "primary",
                                        block: "",
                                        disabled: !_vm.isValid
                                      },
                                      on: { click: _vm.handleFormSubmit }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("login.sign-in-button")
                                          ) +
                                          " "
                                      ),
                                      _c("portal-icon", {
                                        staticClass: "ml-2",
                                        attrs: { name: "arrow-right", size: 17 }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("v-checkbox", {
                                    staticClass: "login-remember",
                                    attrs: {
                                      label: _vm.$t("login.remember-email"),
                                      "hide-details": "",
                                      dense: "",
                                      value: true
                                    },
                                    model: {
                                      value: _vm.rememberEmail,
                                      callback: function($$v) {
                                        _vm.rememberEmail = $$v
                                      },
                                      expression: "rememberEmail"
                                    }
                                  }),
                                  _vm.entryScreen !== "start"
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "login-back",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              _vm.entryScreen = "start"
                                            }
                                          }
                                        },
                                        [
                                          _c("portal-icon", {
                                            attrs: {
                                              name: "arrow-left",
                                              size: 18
                                            }
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("login.all-options")
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm.view === "email-sent"
                            ? _c(
                                "section",
                                {
                                  staticClass: "login-success",
                                  attrs: { "aria-live": "polite" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "login-success__icon" },
                                    [
                                      _c("portal-icon", {
                                        attrs: {
                                          name: "circle-check",
                                          size: 28
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("login.magic-link")) + " "
                                    ),
                                    _c("strong", [_vm._v(_vm._s(_vm.email))]),
                                    _vm._v(
                                      ". " + _vm._s(_vm.$t("login.click-link"))
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                : _c("v-container", { staticClass: "login-card__content" }, [
                    _c("div", { staticClass: "login-unavailable" }, [
                      _c(
                        "span",
                        { staticClass: "login-success__icon" },
                        [
                          _c("portal-icon", {
                            attrs: { name: "alert-circle", size: 28 }
                          })
                        ],
                        1
                      ),
                      _c("h1", [
                        _vm._v(_vm._s(_vm.$t("login.feature-not-enabled")))
                      ])
                    ])
                  ])
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }